module.exports = __webpack_public_path__ + "img/home-wxcode.4cd0f0b7.png";